function addLink(text) {
  // Regular expression to find URLs
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  
  // Split the text into parts that are either URLs or non-URLs
  const parts = text.split(urlPattern);

  return parts.map((part, index) => {
    // If the part matches the URL pattern, return it as a clickable link
    if (urlPattern.test(part)) {
      return (
        <a href={part} key={index} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    // Otherwise, return the text as is
    return part;
  });
}

function getEmbedUrl(url) {
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  const match = url.match(youtubeRegex);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }
  return null;
};

function getGifUrl(message) {
  const urlRegex = /(https?:\/\/[^\s]+\.gif)/g;
  const urls = message.match(urlRegex);

  if (urls) {
    return urls[0]; // Return the first .gif URL found
  }

  return null;
}

export { addLink, getEmbedUrl, getGifUrl }
